import React from 'react';

const EntityInfoGrid = ({ items = [] }) => {
  return (
    <div className="grid grid-cols-4 gap-x-10 gap-y-5 text-sm">
      {items.map((item) => (
        <div key={item.label} className="flex items-center justify-between gap-3">
          <span className="font-bold text-gray-800 whitespace-nowrap">{item.label}</span>
          <span className="text-gray-700 whitespace-nowrap">{item.value ?? '-'}</span>
        </div>
      ))}
    </div>
  );
};

export default EntityInfoGrid;
